(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("PacktDataStructuresAlgorithms", [], factory);
	else if(typeof exports === 'object')
		exports["PacktDataStructuresAlgorithms"] = factory();
	else
		root["PacktDataStructuresAlgorithms"] = factory();
})(window, function() {
return 